import React from "react";
import { Link } from "react-router-dom";
import icon1 from "../../images/icon/sms-black.png";
import icon2 from "../../images/icon/call-balck.png";
import icon3 from "../../images/icon/loc-black.png";
import icon4 from "../../images/icon/sms02.svg";
import Services from "../../api/service";
import logo from "../../images/logo/Logo-2-01.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const SubmitHandler = (e) => {
  e.preventDefault();
};

const Footer = (props) => {
  return (
    <footer
      className="footer footer-style-two pt-200 bg_img pos-rel"
      style={{ backgroundColor: "#0c111d" }}
    >
      <div className="container">
        <div className="xb-footer pt-120">
          <div className="footer-info ul_li_between">
            {/* <div className="info-item ul_li">
              <div className="xb-item--icon">
                <span>
                  <img src={icon1} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Write to us</p>
                <h4 className="xb-item--title"><a href="mailto:hello@tigrispay.com" className="contacts-footer">hello@tigrispay.com</a></h4>
              </div>
            </div>
            <div className="info-item ul_li">
              <div className="xb-item--icon clr-blue">
                <span>
                  <img src={icon2} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Call Us</p>
                <h4 className="xb-item--title"><a href="tel:02030055883" className="contacts-footer">+44 02030055883</a></h4>
              </div>
            </div>
            <div className="info-item ul_li">
              <div className="xb-item--icon clr-sky">
                <span>
                  <img src={icon3} alt="" />
                </span>
              </div>
              <div className="xb-item--holder">
                <p className="xb-item--content">Our Office</p>
                <h4 className="xb-item--title">
                 20-22 Wenlock Road, London, <br/>N1 7GU.
                </h4>
              </div>
            </div> */}
          </div>
          <div className="footer-inner mt-70 mb-100 ul_li_between align-items-start">
            <div className="sa-newslatter footer-widget">
              <img src={logo} style={{ maxWidth: "120px" }} alt="" />
              <br />
              <br />

              {/* <p className="xb-item--content clr-white">
                TigrisPay is a trading name of ADALE DAWIT DAGNACHEW (ADD) LTD, authorised and regulated by the Finanicial Conduct Authority with FRN: 941000. The company is registered under Companies Act 2006 and Companies House registration number is 12005108.
              </p> */}
             <p className="text-white">
       
        Write to us
      </p>
      <h4 className="text-white">
        <a href="mailto:hello@tigrispay.com" className="text-white text-decoration-none">
          <FontAwesomeIcon icon={faEnvelope} className="me-2 text-warning" />
          hello@tigrispay.com
        </a>
      </h4>

            </div>
            <div className="footer-widget">
              <span className="xb-item--sub-title">Quick Links</span>
              <ul className="xb-item--holder list-unstyled">
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/aboutus">
                    About us
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/contact">
                    Contact Us
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/help">
                    Help
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/generalFaq">
                    General Faqs
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-widget">
              <span className="xb-item--sub-title">Legal Links</span>
              <ul className="xb-item--holder list-unstyled">
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/terms-conditions">
                    Terms and Conditions
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/privacy-policy">
                    Privacy Policy
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/datasafty">
                    Data Safety
                  </Link>
                </li>
                <li className="xb-item--list">
                  <Link onClick={ClickHandler} to="/file-a-complaint">
                    File a Complaint
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-copyright mt-70 ul_li_between">
            <p className="copyright mt-20">
              Copyright © 2025{" "}
              <Link onClick={ClickHandler} to="/">
                TigrisPay
              </Link>
              . All rights reserved.
            </p>
            <ul className="footer-link ul_li mt-20">
              <li>
                <span>Follow us :</span>
              </li>
              <li>
                <Link onClick={ClickHandler} to="/">
                  <i className="fab fa-twitter"></i>
                </Link>
              </li>
              <li>
                <Link onClick={ClickHandler} to="/">
                  <i className="fab fa-facebook-f"></i>
                </Link>
              </li>
              <li>
                <Link onClick={ClickHandler} to="/">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
